export const currentYear = new Date().getFullYear();

export const todayDate = new Date().toISOString().split('T')[0];

export const isToday = (date: string) => {
  const formatter = new Intl.DateTimeFormat('es-ES');
  const today = formatter.format(new Date());
  const dateToCheck = formatter.format(new Date(date));

  return dateToCheck === today;
};

export const formatDate = (date: string) =>
  new Date(date).toLocaleDateString(undefined, { month: 'long', year: 'numeric', day: 'numeric' });
